import { Injectable } from '@angular/core';
import { UserToken } from 'app/modules/chart/interface/interfaces';
import { Actions, AppStore } from '../index';
import { ReduxAction, ReduxType } from '../interface';

@Injectable()
export class UserTokenActions extends Actions {
  constructor(appStore: AppStore) {
    super(appStore);
  }

  public getToken(user: UserToken): ReduxAction<UserToken> {
    return { type: ReduxType.GET_TOKEN, payload: user };
  }
}
